import ExamRepository from './exam'

export default {
  Exam: ExamRepository
}
